export const SPECIALTIES = [
  "Cardiology & Internal Medicine",
  "Chiropractic",
  "Dentistry",
  "Dermatology",
  "Emergency Medicine",
  "Gastroenterology",
  "Internal Medicine",
  "Neurological & Spine Surgery",
  "Neurology",
  "Ophthalmology",
  "Optometry",
  "Orthopedic Spine Surgery",
  "Orthopedic Surgery",
  "Orthopedics",
  "Otolaryngology (ENT)",
  "Pain Management",
  "Physical Medicine & Rehabilitation",
  "Podiatry",
  "Psychiatry & Neuropsychology",
  "Psychology",
  "Psychology & Neuropsychology",
  "Pulmonary Medicine",
  "Urology",
];
